// @ts-ignore
import { legic } from '@/lib/legic.ts'
// @ts-ignore
import URL from '@/lib/url.ts'
import native from '@zz-common/native-adapter'
import { getPPU, getUID, getT, getCookie } from '@/lib/cookie'
// @ts-ignore
import { shareCommonFn, isZhuanZhuan } from '@/lib/util.ts'
// @ts-ignore
import VARS from '@/lib/vars.ts'
// import Toast from '@/components/common/toast/index.js'
// import { loadStart, loadEnd } from '@/components/common/loadStartEnd'

export const isZZ = isZhuanZhuan()

// 如果不用函数延迟计算而直接字面量的方式，得到的结果很可能不正确，
// 因为对于 h5页面来说，代码运行的时候页面上可能还没注入 wx 对象
// export const isZZWA = () => typeof wx === 'object'
export const isZZWA = () => native.in('wa')

/*
  sdk api列表：

  login                      // 登录
  isLogin                    // 判断是否登录

  setRightShareBtn           // 设置右上角分享
  setSharePanel              // 调起分享面板
  shareToPlatform            // 直接分享到指定平台
  setMiniAppShareInfo        // 设置分享到小程序信息
  setWechatShareInfo         // 设置分享到微信浏览器信息
  setShareInfo               // 设置分享信息
  setRightUnifiedButton      // 设置右上角按钮
  setTitle                   // 设置页面标题
  toast                      // toast提示
  enterUnifiedUrl            // 调用统跳协议页面
  chooseAddress              // 调起地址选择页
  uploadPhotos               // 图片上传
  getCoordinate              // 获取经纬度
  loadingStart               // 展示loading
  loadingEnd                 // 隐藏loading
  closeCurrentPage           // 关闭当前 webview
  registerPageCallback       // 注册一个获取webview生命周期的回调
  getStatusBarHeight         // 获取挖孔屏 statusBar 高度
  getGeoLocation             // 客户端内获取经位置信息
  choostMapLocation          // 地图选择位置后的回调

  skipToUrl                  // 跳转
  enterProfile               // 进入个人主页
  enterMyBuyList             // 进入我买到的列表页
  enterDetail                // 商品详情

  invokePay                  // 调起支付
*/

// 小程序登录完成后，需要加载sdk，存在一段时间的延迟，然后才会真正写入cookie，
// 可能在 created 函数调用之前都没能加载完，也就拿不到登录状态，所以这里异步轮询一下
export const wait4AsyncLogin = async () => {
  return new Promise((resolve) => {
    // 如果是在转转app中，则直接以 isLogin为准
    if (isZhuanZhuan()) {
      return resolve(isLogin())
    }
    // 如果是在小程序内就需要轮询一下
    // 主程序加载h5页面，默认是会自动给 h5页面进行登录，所以 h5页面一般都具备登录态，
    // 如果没拿到登录态可能就是异步的原因导致的，因而进行轮询查询
    const polling4Login = (addIndex = 0) => {
      // 超过一定次数还是没有登录上就认为确实是没有登录
      if (addIndex > 40) {
        return resolve(false)
      }
      return isLogin()
        ? resolve(true)
        : setTimeout(() => {
          polling4Login(addIndex + 1)
        }, 80)
    }
    polling4Login()
  })
}
/**
 * 登录
 */
export const login = async (callback: Function) => {
  console.log('是否是登录状态', isLogin())
  const loginStatus = await wait4AsyncLogin()
  if (loginStatus) {
    return callback({
      PPU: getPPU(),
      uid: getUID(),
      t: getT(),
      code: 0
    })
  }
  // 因为 https://s1.zhuanstatic.com/common/zzwa/static/js/zzwasdk-v1.3.2.js 这个小程序的adapter登录能力有问题，所以我们自己做这个登录
  // 原理就是去掉链接带的  __waneednotauth || needNotAuth 参数，主程序的webview承载页会自动对页面进行登录
  if (isZZWA()) {
    const hashQueryObj = URL.getHashParam(location.hash)
    let newHashQuery = ''
    // 过滤掉 __waneednotauth || needNotAuth
    Object.keys(hashQueryObj)
      .filter((item) => item !== '__waneednotauth')
      .filter((item) => item !== 'needNotAuth')
      .forEach((item, index) => {
        newHashQuery += (index === 0 ? '?' : '&') + item + '=' + hashQueryObj[item]
      })
    let newUrl = 'https://m.zhuanzhuan.com/enjoy-given/eg/index.html#/content/index'
    try {
      newUrl =
        location.origin + location.pathname + location.hash.replace(/(\?|&).*/, '') + newHashQuery
    } catch (e) {
      console.log(e)
    }
    console.log(999, newUrl)
    // 过滤掉 __waneednotauth 参数，拼接出新的 url，并重定向，让 主程序的 webview页来进行登录
    return wx.miniProgram.redirectTo({
      url: '/pages/webview/webview?url=' + encodeURIComponent(newUrl)
    })
  }
  native.login((res: any) => {
    console.log('login', res)
    if (+res.code === 0) {
      legic('H5CHECKIN_LOGIN_SUCCESS')
      callback({
        PPU: getPPU(),
        uid: getUID(),
        t: getT(),
        code: 0
      })
    } else {
      legic('H5CHECKIN_LOGIN_FAIL')
      callback({
        PPU: '',
        uid: '',
        t: getT(),
        code: -1
      })
    }
  })
}

/**
 * 判断是否登录
 */
export const isLogin = () => {
  return native.isLogin()
}

/**
 * 注册，里面包括发送验证码，注册验证的逻辑
 */
// export const register = () => {
//   ZZLoginBridge.register()
// }

type PanelType = 'allChannel' | 'onlyWeixin'
type ShareType = 'common' | 'poster'
type ButtonType = 'icon' | 'label'
type NeedLogin = '0' | '1'

// 公共分享参数
interface ShareCommonObj {
  title: string // 分享标题
  content: string // 分享内容
  picPath: string // 分享图片地址
  url: string // 分享跳转地址
  posterPicPath?: string // 分享海报底图地址
  shareType?: ShareType // 分享类型(common：普通， poster：海报)
  miniAppShare?: any // 小程序分享参数{title, content, appId, path, pic}
  shareParam?: any // 商品分享参数，可以看商品详情页的该参数
  twoDimensionCodeX?: string // 二维码的X坐标(qrX，qrY，qrW三个参数若有一个未传，则海报使用固定大小风格，若全部传入，则海报大小是server端下发的实际大小)
  twoDimensionCodeY?: string // 二维码的Y坐标
  twoDimensionCodeW?: string // 二维码的宽度(方形)
  twoDimensionCodeColor?: string // 二维码的颜色(示例 #00ff00)
  color?: string // 按钮文案颜色（默认 #FB5329）
  goodsInfo?: any // 商品分享参数，与shareParam结合使用（至少需要：infoId, pic）
  wechatZonePic?: string // 朋友圈分享图片（如果posterPicPath不好使,可以用这个字段）
  logParam?: string // 分享成功后要上报的参数(如主题id或好友在卖等活动标识)
}

// 分享参数
interface ShareObj extends ShareCommonObj {
  panelType?: PanelType // 分享面板类型(allChannel：全渠道， onlyWeixin：只有微信、朋友圈)
  buttonType?: ButtonType // 分享按钮类型(icon：图标，label：文字)
  needLogin?: NeedLogin // 点击右侧按钮时是否需要登录 '0'：不需要登录 '1'：需要登录
  guidePage?: {
    pagePic?: string
    bgColor?: string
  }
}

/**
 * 设置右上角分享
 */
export const setRightShareBtn = (obj: ShareObj, callback?: Function) => {
  if (isZZ) {
    native.wrap('setRightShareBtn')(obj, callback)
  }
}

/**
 * 调起分享面板
 */
export const setSharePanel = (obj: ShareObj, callback?: Function) => {
  if (isZZ) {
    shareCommonFn('setSharePanel', obj, callback)
  }
}
/**
 * 拨打电话
 */
interface TelephoneObj {
  phoneNum: string // 电话号码
}
export const callTelephone = (obj: TelephoneObj, callback?: Function) => {
  if (isZZ) {
    shareCommonFn('callTelephone', obj, callback)
  }
}

/**
 * 直接分享到指定平台
 */
interface ShareToPlatformObj extends ShareCommonObj {
  platform?: string
  // 分享某平台(weixin:微信好友, weixin_zone:微信朋友圈, qq: qq好友, q_zone: qq空间, sina_weibo:微博,copy_link:复制链接)
  panelType?: string
  guidePage?: {
    pagePic?: string
    bgColor?: string
  }
}
export const shareToPlatform = (obj: ShareToPlatformObj, callback?: Function) => {
  if (isZZ || VARS.isWXWebviewFn()) {
    shareCommonFn('shareToPlatform', obj, callback)
  } else {
    // callback();
  }
}
/**
 * 重置右上角按钮
 */
export const resetRightAllButton = (callback?: Function) => {
  if (isZZ) {
    native.wrap('resetRightAllButton')(callback)
  } else {
    callback && callback()
  }
}
/**
 * 设置分享信息
 */
// 分享某平台(weixin:微信好友, weixin_zone:微信朋友圈, qq: qq好友, q_zone: qq空间, sina_weibo:微博,copy_link:复制链接)
interface SetShareInfoBackUpObj {
  isMiniApp?: boolean // 是否为小程序分享 true：是， false：h5分享
  miniPath?: string // 小程序链接
  miniAppId?: string // 小程序原始id  如：gh_65f597c8fe85
}
type platformType = 'weixin' | 'weixin_zone' | 'qq' | 'q_zone' | 'sina_weibo' | 'copy_link'
interface SetShareInfoObj {
  title: string // 分享标题
  content: string // 分享内容
  picPath: string // 分享图片地址
  url: string // 分享跳转地址
  actionType?: string // 只有是分享小程序的链接，才需要加这个
  platform?: platformType[] // 分享某平台(weixin:微信好友, weixin_zone:微信朋友圈, qq: qq好友, q_zone: qq空间, sina_weibo:微博,copy_link:复制链接)
  backUp?: SetShareInfoBackUpObj // 分享附加参数
  waImg?: string // 用于 adapter
}
/**
 * 设置分享到小程序信息
 */
export const setMiniAppShareInfo = (obj: SetShareInfoObj, callback?: Function) => {
  setRightUnifiedButton(
    {
      imgUrl: 'https://pic5.zhuanstatic.com/zhuanzh/n_v23fde2f426bf944c28adea0e182a30ee8.png'
    },
    (res: any) => {
      // code为0表示用户点击
      if (res.code - 0 === 0) {
        shareCommonFn(
          'shareToPlatform',
          {
            title: obj.title,
            content: obj.content,
            picPath: obj.picPath,
            url: obj.url,
            platform: 'weixin',
            miniAppShare: {
              title: obj.title,
              content: obj.content,
              appId: obj.backUp.miniAppId,
              path: obj.backUp.miniPath,
              pic: obj.picPath
            }
          },
          callback
        )
      }
    }
  )
}

/**
 * 设置分享到微信浏览器信息
 */
export const setWechatShareInfo = (obj: SetShareInfoObj, callback?: Function) => {
  setRightUnifiedButton(
    {
      imgUrl: 'https://pic5.zhuanstatic.com/zhuanzh/n_v23fde2f426bf944c28adea0e182a30ee8.png'
    },
    (res: any) => {
      // code为0表示用户点击
      if (res.code - 0 === 0) {
        shareCommonFn(
          'shareToPlatform',
          {
            title: obj.title,
            content: obj.content,
            picPath: obj.picPath,
            url: obj.url,
            platform: 'weixin'
          },
          callback
        )
      }
    }
  )
}

export const setShareInfo = (obj: SetShareInfoObj, callback?: Function) => {
  if (isZZ) {
    resetRightAllButton(() => {
      // 默认写死只分享微信
      if (!obj.platform) {
        obj.platform = ['weixin']
      }
      // 指定小程序分享（目前仅支持小程序分享）
      if (obj.platform.indexOf('weixin') > -1 && obj.backUp && obj.backUp.isMiniApp) {
        setMiniAppShareInfo(obj, callback)
        // 未指定小程序默认分享到微信h5
      } else {
        setWechatShareInfo(obj, callback)
      }
    })
  } else {
    native.share(obj, callback)
  }
}

/**
 * 设置右上角按钮（多次调用可以添加多个按钮）
 */
interface SetRightUnifiedButtonObj {
  imgUrl?: string // 右上角设置icon图片地址, 如果imgUrl和label都设置了,native只识别imgUrl
  label?: string // 右上角设置文案内容, 如果imgUrl和label都设置了,native只识别imgUrl
  color?: string // 右上角设置文案的颜色
  jumpUri?: string // 跳转目标页面的统一跳转协议
  tag?: string // 按钮的tag，多次调用此接口，若tag相同, 则修改对应的按钮, 否则新增按钮(4.5新增字段，购物车项目)
}
// 注：callback 回调方法,会返回res对象， 且返回的res中(res.code - 0 === 0)时，才表示用户点击触发
export const setRightUnifiedButton = (obj: SetRightUnifiedButtonObj, callback?: Function) => {
  if (isZZ) {
    native.wrap('setRightUnifiedButton')(obj, callback)
  }
}

/*
 * 设置页面标题
 * */
interface SetTitle {
  title: string // 需要设置的标题字符串
  prefectureId?: string // 专区ID
}
export const setTitle = (obj: SetTitle, callback?: Function) => {
  if (isZZ) {
    native.setTitle(obj, callback)
  } else {
    document.title = obj.title
  }
}

/*
 * toast提示
 * */
interface ToastObj {
  msg: string // 提示信息
  style?: '0' | '1' | '2' | '3' // 不传没有图标，图标风格（1：成功，对号；2：失败，叉号；3：提醒，感叹号)
  duration?: number // toast每次显示的时长 ms
}
export const toast = (obj: ToastObj, callback?: Function) => {
  if (isZZ) {
    native.wrap('toast')(obj, callback)
  }
  // else {
  //   if (!obj.msg) {
  //     obj.msg = '错误'
  //   }
  //   Toast(obj)
  // }
}

/*
 * 调用统跳协议页面
 * */
interface EnterUnifiedUrlObj {
  unifiedUrl: string // 跳转目标页面的统一跳转协议 (统跳协议文档: http://dashen.zhuanspirit.com/pages/viewpage.action?pageId=10489465)
  needClose?: '0' | '1' // 是否关闭当前页 ( 1: 关闭当前页面 , 0 不关闭)
}
export const enterUnifiedUrl = (obj: EnterUnifiedUrlObj, callback?: Function) => {
  if (isZZ) {
    native.wrap('enterUnifiedUrl')(obj, callback)
  }
}

/**
 * 调起地址选择页
 */
interface ChooseAddressObj {
  addressId?: string // 默认选中的收货地址id，给 app用的，webview不需要这个字段
  addressInfo?: string | object // 默认的地址信息，包括 name，city等属性在内的一个的对象, 或这个对象序列化后的对象字符串，给 webview用的，app不需要这个字段
}
export const chooseAddress = (obj: ChooseAddressObj, callback?: Function) => {
  if (isZZ) {
    native.wrap('chooseAddress')(obj, callback)
  } else {
    const defaultAddress = obj.addressInfo
      ? '?default_address=' +
        encodeURIComponent(
          typeof obj.addressInfo === 'object' ? JSON.stringify(obj.addressInfo) : obj.addressInfo
        )
      : ''
    console.log('defaultAddress:', defaultAddress)
    wx.miniProgram.navigateTo({ url: '/subPages/functional/address' + defaultAddress })
  }
}

/**
 * 设置标题栏可见性
 */
interface SetHeaderVisible {
  visible?: string // 默认选中的收货地址id
}
export const setHeaderVisible = (obj: SetHeaderVisible = { visible: '1' }, callback?: Function) => {
  if (isZZ) {
    native.wrap('setHeaderVisible')(obj, callback)
  }
}

/**
 * 图片上传
 */
interface UploadPhotosObj {
  maxAllowCount?: string // 最大允许上传图片的张数
  selectedList?: string[] // 当前已经上传的图片列表，数据项要是图片的纯文件名，不带域名和后缀
}
export const uploadPhotos = (
  obj: UploadPhotosObj = { maxAllowCount: '9' },
  callback?: Function
) => {
  // code : 0 上传开始 , 1上传全部成功, 2 上传部分失败 3 上传全部失败
  // code为 1 或 2 时,对应上传的图片地址，多张以 | 分割（✘✘.png|✘✘.png|✘✘.png）
  try {
    native.uploadPhotos(obj, callback)
  } catch (e) {
    console.log('上传图片错误：', e)
  }
}

/**
 * 获取经纬度
 * @param callback 回调函数
 * @param timeout 用于控制超时，如果超过超时时间扔拿不到地址可以默认失败，避免用户等待太久影响用户体验，只在 webveiw端有效
 */
export const getCoordinate = (callback?: Function, timeout?: number) => {
  console.log('getCoordinate-:', isZZWA())
  let readyFlag = false
  let currentDone = false
  if (isZZ) {
    native.wrap('getCoordinate')(callback)
  } else if (isZZWA()) {
    // 所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
    // 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
    wx.ready(function () {
      // android端wx.ready回调函数执行了两次.
      if (!readyFlag) {
        readyFlag = true
        wx.getLocation({
          complete(res) {
            if (currentDone) {
              return
            }
            currentDone = true
            console.log('addresssId212:', JSON.stringify(res))
            if (res.errMsg.indexOf('ok') !== -1) {
              callback({
                lon: res.longitude,
                lat: res.latitude,
                code: '0'
              })
            } else {
              callback({ code: '-1' })
            }
          }
        })
        // 用于控制超时
        if (timeout) {
          setTimeout(() => {
            if (currentDone) {
              return
            }
            currentDone = true
            callback({ code: '-1' })
          }, timeout)
        }
      }
    })
  } else {
    callback && callback({ code: '-1' })
  }
}

/**
 * 展示loading (状态modal，类似于小程序的 wx.showLoading())
 */
interface LoadingStartObj {
  canCancel?: string // 是否可以手动取消，“1”可以取消，"0"或者其他值不可取消（Android使用，不传则默认可以为"1"）
  msg?: string // loading提示文字
}
export const loadingStart = (obj: LoadingStartObj, callback?: Function) => {
  if (isZZ) {
    native.wrap('loadingStart')(obj, callback)
  }
  // else {
  //   loadStart(obj)
  // }
}

/**
 * 隐藏loading (状态 modal，类似于小程序的 wx.hideLoading())
 */
export const loadingEnd = (callback?: Function) => {
  if (isZZ) {
    native.wrap('loadingEnd')(callback)
  }
  // else {
  //   loadEnd(callback)
  // }
}

/**
 * 关闭当前 webview
 */
export const closeCurrentPage = (callback?: Function) => {
  if (isZZ) {
    native.wrap('close')(callback)
  } else if (isZZWA()) {
    wx.miniProgram.navigateBack()
  } else {
    window.history.go(-1)
  }
}

/**
 * 跳转
 */
interface SkipToUrlObj {
  targetUrl: string // 跳转链接，必须是绝对路径
  newPageTitle?: string // 目标页面的标题 -仅适用于转转app、赶集app、58app
  needClose?: string // 是否关闭当前源页面(传 0: 不关闭; 1: 关闭) - 仅适用于转转app
  disableShare?: string // 跳转页面不设置分享（1: 不设置；0：设置）- 仅适用于主程序
}
/**
 * 跳转页面
 * @param obj
 * @param vueInstance vue实例句柄，用于调用其上的路由方法，直接以切换 hash的方式切换页面
 */
export const skipToUrl = (obj: SkipToUrlObj) => {
  let targetUrl = obj.targetUrl || ''
  if (isZZWA()) {
    if (obj.disableShare === '1') {
      targetUrl = URL.setQueryParam(targetUrl, { __wadisableshare: 1 })
    }
    console.log(999, targetUrl, obj)
    if (!/^\/?pages/.test(targetUrl)) {
      // 如果没带域名
      if (!/^(https?|\/\/)/.test(targetUrl)) {
        const mt = window.location.href.match(/(.+#\/)(.+)/)
        if (!mt) {
          return toast({ msg: 'skipuToUrl跳转失败' })
        }
        targetUrl = mt[1] + targetUrl
      }
      // 替换为 小程序 webview的全路径地址
      targetUrl = 'pages/webview/webview?url=' + encodeURIComponent(targetUrl)
    }
  }
  native.skipToUrl(Object.assign({}, obj, { targetUrl }))
}

/**
 * 进入个人主页 - 支持 微信小程序
 */
interface EterProfileObj {
  uid: string // 用户userId
  userId: string
}
export const enterProfile = (obj: EterProfileObj) => {
  if (isZZ) {
    native.wrap('enterProfile')({ ...obj, userId: obj.uid })
  } else {
    native.enterProfile(obj)
  }
}

/**
 * 进入我买到的列表页
 */
export const enterMyBuyList = () => {
  if (isZZ) {
    enterUnifiedUrl({
      unifiedUrl: 'zhuanzhuan://jump/core/myBuyList/jump?tab=gift'
    })
  } else if (isZZWA()) {
    skipToUrl({
      targetUrl:
        'https://m.zhuanzhuan.com/platform/zzappsupport/index.html?type=buy#/enjoygiven/mine'
    })
  }
}

/**
 * 调起支付
 */
interface InvokePayObj {
  payMethod: string // 支付方式（0-微信 1- 京东 2-支付宝）
  payData: string // 支付数据,json字符串
}
export const invokePay = (obj: InvokePayObj, callback: Function) => {
  if (isZZ) {
    native.wrap('invokePay')(obj, callback)
  }
}

/**
 * 注册一个获取webview生命周期的回调
 * 返回的callback参数{code: '0', pageState: 1}： {
 * pageState:
 *   1: "当前页面显示",
 *   2: "当前页面隐藏或被覆盖",
 *   3: "当前页面已关闭或销毁",
 *   4: "当前页面显示，并接收到传入的参数等"
 * }
 */
export const registerPageCallback = (callback: any) => {
  if (isZZ) {
    native.wrap('registerPageCallback')({ useOrigin: true, callback })
  }
}
/**
 * 保存图片到相册
 */
interface LaunchAlbumObj {
  imageUrl: string
}
export const launchAlbum = (obj: LaunchAlbumObj, callback?: Function) => {
  if (isZZ) {
    native.wrap('launchAlbum')(obj, callback)
  }
}

interface EnlargeImageObj {
  // 必填项，图片的完整路径，如果多个，以竖线 | 分割
  imgUrls: string
  // 必填项，被选中的图片的索引
  selectedIndex: string
}
/**
 * 预览图片
 * @param obj 预览参数
 */
export const enlargeImage = (obj: EnlargeImageObj) => {
  console.log('预览图片：', JSON.stringify(obj))
  if (isZZ) {
    native.wrap('enlargeImage')(obj)
  } else if (isZZWA()) {
    const urls = obj.imgUrls.split('|')
    wx.previewImage({
      urls,
      current: urls[obj.selectedIndex]
    })
  }
}

/**
 * onShow方法
 * @param obj 预览参数
 */
export const onShow = (callback: Function) => {
  // 转转app
  if (isZZ) {
    registerPageCallback((rst: any) => {
      if (+rst.code === 0 && +rst.pageState === 1) {
        callback()
      }
    })
    // 小程序
  } else if (isZZWA()) {
    native.wrap('onShow')(callback)
  }
}

export function compareVersion(v1, v2) {
  if (typeof v1 !== 'string') {
    return false
  }
  if (typeof v2 !== 'string') {
    return false
  }
  v1 = v1.split('.')
  v2 = v2.split('.')
  const k = Math.min(v1.length, v2.length)
  for (let i = 0; i < k; ++i) {
    v1[i] = parseInt(v1[i], 10)
    v2[i] = parseInt(v2[i], 10)
    if (v1[i] > v2[i]) {
      return 1
    }
    if (v1[i] < v2[i]) {
      return -1
    }
  }
  return v1.length === v2.length ? 0 : v1.length < v2.length ? -1 : 1
}

/**
 * 获取挖孔屏 statusBar 高度
 * 支持版本：客户端 6.10.0+
 */
interface isStatusBarSupportRst {
  support: string // 0 不支持， 1 支持
}
interface statusBarHeightRst {
  height: string
}
export interface StatusBarRes {
  code: string
  height?: number
  msg?: string
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getStatusBarHeight = (callback: (param: StatusBarRes) => void) => {
  // console.log('获取挖孔屏 statusBar 高度', URL.getQueryObject())
  if (isZZ && compareVersion(URL.getQueryObject()['zzv'] || getCookie('v'), '6.10.0')) {
    native.wrap('isStatusBarSupportTransparent')(function (res: isStatusBarSupportRst) {
      // console.log('是否支持挖空屏', res)
      if (res.support === '1') {
        native.wrap('getStatusBarHeight')(function (res: statusBarHeightRst) {
          // console.log('挖空屏 statusBar height = ', res)
          callback({ code: '0', height: +res.height, msg: 'ok' })
        })
      } else {
        // console.log('此手机不支持 statusBar 穿透')
        callback({ code: '-1', msg: '此手机不支持 statusBar 穿透' })
      }
    })
    native.wrap('getStatusBarHeight')({}, function (height: string) {
      console.log('getStatusBarHeight=', height)
    })
  } else {
    // console.log('getStatusBarHeight: 非客户端版本，或客户端版本太低');
    callback({
      code: '-1',
      msg: '非客户端版本，或客户端版本太低'
    })
  }
}

/**
 * 客户端内获取经位置信息
 * 小程序支持？
 */
interface CoordinateRsp {
  code: String
  long: String
  lat: String
  msg?: String
}
export const getGeoLocation = (callback: Function) => {
  if (isZZ) {
    native.getCoordinate((res: CoordinateRsp) => {
      callback(res)
    })
  } else {
    callback({ code: '-1' })
  }
}

/**
 * 地图选择位置后的回调
 * coordtype:
 * 1.GPS坐标
 * 2.sogou经纬度
 * 3.baidu经纬度
 * 4.mapbar经纬度
 * 5.[默认]腾讯、google、高德坐标
 * 6.sogou墨卡托
 */
interface GeoParam {
  lat: string
  lon: string
  coordtype?: string
}
export const choostMapLocation = (param?: GeoParam, callback?: () => void) => {
  if (isZZ) {
    native.getMapLocation(param, callback)
  }
}

/**
 * native 中预览视频和图片
 */
interface MediaParamObj {
  imgUrls: string
  videoVos: string[]
  selectedIndex: string
}
export const previeImageOrVideo = (param: MediaParamObj, callback?: () => void) => {
  if (isZZ) {
    native.wrap('enlargeImgsOrVideo')(param, callback)
  }
}

/**
 * 跳到商品详情
 */
interface EnterDetailObj {
  infoId: string
  metric: string
}
export const enterDetail = (param: EnterDetailObj, callback?: () => void) => {
  native.wrap('enterDetail')(param, callback)
}

/**
 * 获取 app 推送开关状态
 * 小程序兼容：小程序中默认返回打开状态
 * res.code == '1' 打开状态
 * @param {Function} callback
 */
export const getSysPushSettingState = (callback) => {
  if (VARS.isWXWebviewFn()) {
    callback(true)
  } else {
    native.wrap('getSysPushSettingState')((res) => {
      // iOS 回调调用两次，其中一次为空对象
      if (Object.keys(res).length) {
        // callback(res);
        if (res.code == '1') {
          // 处于打开状态
          callback(true)
        } else {
          // 没有打开推送
          callback(false)
        }
      }
    })
  }
}

/**
 * 如果推送未打开，打开系统通知设置
 * @param {Function} callback
 */
export const openSysPushSetting = (callback) => {
  native.wrap('openSysPushSetting')((res) => {
    // iOS 回调两次，android 回调空字符串
    if (Object.keys(res).length == 0) {
      callback(res)
    }
  })
}
